import React from 'react';
import { NotificationsDropdown } from '../components/notificationsDropdown/NotificationsDropdown';
import { ProfileDropdown } from '../components/profileDropdown/ProfileDropdown/ProfileDropdown';
import { SettingsDropdown } from '../components/settingsDropdown/SettingsDropdown';
import * as S from '../Header.styles';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { useHeader } from './HeaderContext';
import { BaseSpace } from '@app/components/common/BaseSpace/BaseSpace';

interface MobileHeaderProps {
  toggleSider: () => void;
  isSiderOpened: boolean;
  breadcrumb: React.ReactNode;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({ toggleSider, isSiderOpened, breadcrumb }) => {
  const { headerButtons } = useHeader();

  return (
    <>
      <BaseRow justify="space-between" align="middle" style={{ marginBottom: '0px', marginTop: '0px', height: '30px' }}>
        <BaseCol>
          <ProfileDropdown />
        </BaseCol>

        <BaseCol>
          <BaseRow align="middle">
            {/* <BaseCol>
              <NotificationsDropdown />
            </BaseCol> */}

            {/* <BaseCol>
              <SettingsDropdown />
            </BaseCol> */}
          </BaseRow>
        </BaseCol>

        <S.BurgerCol>
          <S.MobileBurger onClick={toggleSider} isCross={isSiderOpened} />
        </S.BurgerCol>
      </BaseRow>

      <BaseRow style={{ marginTop: '10px', height: '30px' }}>
        <BaseCol>{breadcrumb}</BaseCol>
      </BaseRow>

      <BaseRow style={{ marginTop: '0', paddingTop: '0' }}>
        <BaseCol>
          <BaseSpace size="small">
            {headerButtons.map((button) => (
              <React.Fragment key={button.id}>{button.element}</React.Fragment>
            ))}
          </BaseSpace>
        </BaseCol>
      </BaseRow>
    </>
  );
};
